import axios from 'axios';

// Create an Axios instance with base URL
const token = localStorage.getItem("token");
const api = axios.create({
//  baseURL: 'http://localhost:9090/api', // change this to your Spring Boot base URL
//    baseURL: 'http://3.108.200.52/api',
//    baseURL: 'https://adv.vibrantasia.com/api',
      baseURL: 'https://adv.vibrantscreen.in/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    // Don't attach token for login request
    if (!config.url.includes('/auth/login')) {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// API methods
const get = (url, config = {}) => api.get(url, config);
const post = (url, data, config = {}) => api.post(url, data, config);
const put = (url, data, config = {}) => api.put(url, data, config);
const del = (url, config = {}) => api.delete(url, config);


const uploadSnapshot = (meetingId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return api.post(`/meetingsmediacontroller/${meetingId}/snapshot`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// Upload Video
const uploadVideo = (meetingId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return api.post(`/meetingsmediacontroller/${meetingId}/video`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// Upload Invitee File
const uploadInviteeFile = (meetingId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return api.post(`/meetingsmediacontroller/${meetingId}/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export default {
  get,
  post,
  put,
  delete: del,
  uploadSnapshot,
  uploadVideo,
  uploadInviteeFile
};
